<template>
  <div class="tone-banner-content">
    <div
      class="tone-banner-image"
      :style="{ backgroundImage: `url(${tonePageStoreBannerImageSrc})` }"
    ></div>
    <div class="tone-overlay-image">
      <h1 class="tone-banner-title">
        {{ tonePageStoreBannerImageTitle }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import TonePageMixin from "@/mixins/tone-page-mixin"
import { TonePageStore } from '@/store/verbal-identity-page/tone-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class ToneBannerSection extends Mixins(TonePageMixin) {
  tonePageStore: PageStoreContract = getModule(TonePageStore, this.$store)

  get tonePageStoreBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get tonePageStoreBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getTonePageStore(): Promise<void> {
    await this.tonePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.tonePageStore.isLoading) {
      await this.getTonePageStore()
    }
  }
}
</script>

<style lang="scss">
.tone-banner-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  max-height: 28rem;
  width: 100%;
  justify-items: center;
  justify-content: center;
}

.tone-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.tone-overlay-image {
  position: absolute;
  bottom: 9rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.tone-banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>
